interface Icon404Props {
  className?: string
}

export function Icon404({ className }: Icon404Props) {
  return (
    <svg className={className} width="100%" height="100%" viewBox="0 0 100 100">
      <path d="M50 0L100 50L50 100L0 50L50 0Z" fill="#E02424" />
    </svg>
  )
}
